
export const simpleDataValidation = (value:string|undefined) => {
    const test = /^([ \u00c0-\u01ffa-zA-Z'\-])+$/
    if (value && test.test(value)) {
        return true;
    }
    return false;
}
